import { render } from "./DashboardProducts.vue?vue&type=template&id=dd20b196"
import script from "./DashboardProducts.vue?vue&type=script&lang=js"
export * from "./DashboardProducts.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__